import type { FC } from 'react';
import { memo } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';

import { PostScreenCompactCard } from '@/features/posts/components/feed/PostScreenCompactCard';
import type { GenericPostDetail } from '@/features/posts/types/posts';
import { isWeb } from '@/shared/utils/platform';
import { webScrollBarStyle } from '@/styles/customStyles';

const TILE_WIDTH = 152;

const styles = StyleSheet.create({
  content: { paddingHorizontal: 12, gap: 12 },
  tile: { width: TILE_WIDTH }
});

export const MeinOrtCompactPostRow: FC<{ posts: GenericPostDetail[] }> = memo(
  ({ posts }) => (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={isWeb}
      style={webScrollBarStyle}
      contentContainerStyle={styles.content}
    >
      {posts.map((post) => (
        <View key={post.postId} style={styles.tile}>
          <PostScreenCompactCard post={post} />
        </View>
      ))}
    </ScrollView>
  )
);
MeinOrtCompactPostRow.displayName = 'MeinOrtCompactPostRow';
